const EARNED_LOYALTY_ASSET_BASE = 'https://storage.googleapis.com/offermgmt-prod/offermgmt/images/earned_loyalty'

export const ELITE_MEMBERSHIP_ASSETS = {
    ribbon: 'https://rukmini-ct.flixcart.com/f_auto,q_auto/offermgmt-prod/offermgmt/images/earned_loyalty/PostBookingEliteRibbon.png',
    bannerBg: `${EARNED_LOYALTY_ASSET_BASE}/elite-ribbon-right.svg`,
    calendar: `${EARNED_LOYALTY_ASSET_BASE}/calender-elite.svg`,
    elite: `${EARNED_LOYALTY_ASSET_BASE}/Elite.svg`,
    star: `${EARNED_LOYALTY_ASSET_BASE}/star.svg`,
    membership: `${EARNED_LOYALTY_ASSET_BASE}/Membership.svg`,
    logo: `${EARNED_LOYALTY_ASSET_BASE}/Logo.svg`,
    trackerEnd: `${EARNED_LOYALTY_ASSET_BASE}/elite-track-end.svg`,
    confetti: `${EARNED_LOYALTY_ASSET_BASE}/confetti.gif`,
    lockIcon: `${EARNED_LOYALTY_ASSET_BASE}/lock-icon.svg`,
    progressFill: `${EARNED_LOYALTY_ASSET_BASE}/progress-fill.svg`,
    successTick: `${EARNED_LOYALTY_ASSET_BASE}/step-success.svg`,
    stepperDot: `${EARNED_LOYALTY_ASSET_BASE}/stepper-dot.svg`,
    loginPopup: `${EARNED_LOYALTY_ASSET_BASE}/Container.svg`
} as const

/** Earned Loyalty Pre-booking constants */
export const ELITE_MEMBERSHIP_CHANGE_DATE_FEE = 9
export const ELITE_MEMBERSHIP_HOTEL_DISCOUNT_PERCENT = 25

/** Elite active-member promo banner (fare rules info tooltip / bottomsheet) */
export const EARNED_LOYALTY_ASSET_LOGO = `${EARNED_LOYALTY_ASSET_BASE}/Logo.svg`
export const EARNED_LOYALTY_PROMO_BANNER_COPY = (fee: number) =>
    `Pay ₹${fee} to waive off airline date change charges`
export const EARNED_LOYALTY_PROMO_BANNER_COPY_MINIMAL = (fee: number) => `Pay ₹${fee}`
export const EARNED_LOYALTY_PROMO_BANNER_COPY_MINIMAL_SUBTEXT = 'to get zero airline date change fee'
export const ELITE_MEMBERSHIP_STRIP_GUEST = 'Check your eligibility now'
export const ELITE_MEMBERSHIP_STRIP_PROGRESS = 'Complete 1 more trip to unlock'
export const ELITE_MEMBERSHIP_STRIP_ELITE = 'Yay! Membership benefits unlocked'
export const ELITE_MEMBERSHIP_STRIP_INACTIVE_ZERO = 'Book 2 trips on Cleartrip to unlock'
export const ELITE_MEMBERSHIP_STRIP_TRACKER_EXPIRING_SOON = (date: string) =>
    `Complete next booking before ${date} to unlock`

export const VIEW_ALL_BENEFITS_BUTTON_TEXT = 'View all benefits'
